import {
    mdiAccount,
    mdiBellOutline,
    mdiBullhorn,
    mdiChartLine,
    mdiFlag,
    mdiFormatListBulleted,
    mdiHelpCircleOutline,
    mdiHome,
    mdiMessageQuestionOutline,
    mdiForumOutline,
    mdiStar,
    mdiCog,
    mdiFileDocumentMultipleOutline,
} from "@mdi/js";
import shotSidebarBanner from "@/assets/img/ad/shot_sidebar_banner.png";

// mdiTable
export default [
    // 'メニュー',
    [
        {
            to: "/home",
            icon: mdiHome,
            label: "ホーム",
        },
        {
            to: "/activity",
            icon: mdiFormatListBulleted,
            label: "活動履歴",
        },
        {
            to: "/goal-settings",
            icon: mdiFlag,
            label: "目標設定",
        },
        {
            to: "/mydata",
            icon: mdiChartLine,
            label: "Myデータ",
        },
        {
            to: "/ranking/individual/local",
            icon: mdiStar,
            label: "ランキング",
            submenu: [
                {
                    個人: [
                        {
                            to: "/ranking/individual/local",
                            label: "チーム内ランキング",
                        },
                        {
                            to: "/ranking/individual/national",
                            label: "全国ランキング",
                        },
                    ],
                },
                {
                    チーム: [
                        {
                            to: "/ranking/team/national",
                            label: "全国ランキング",
                        },
                    ],
                },
            ],
        },
        {
            to: "/note",
            icon: mdiFileDocumentMultipleOutline,
            label: "ノート",
        },
        // 'ユーザー',
    ],
    [
        {
            to: "/trainingprofile",
            icon: mdiAccount,
            label: "プロフィール",
        },
        {
            to: "/setting",
            icon: mdiCog,
            label: "機能設定",
        },
        {
            to: "/information",
            icon: mdiBellOutline,
            label: "お知らせ",
        },
        // {
        //     to: '/event-list',
        //     icon: mdiBullhorn,
        //     label: 'イベント',
        // }
    ],
    // その他
    [
        //TODO: ガイドができるまで非表示
        // {
        //     to: '/guide',
        //     icon: mdiHelpCircle,
        //     label: '利用ガイド',
        // },
        // TODO: URL変更
        {
            label: "SPO+TOPへ",
            externalLink: "https://spo-plus.com/top/#/",
        },
        {
            to: "/logout",
            icon: mdiHelpCircleOutline,
            label: "ログアウト",
        },
    ],
    [
        {
            to: "/faq",
            icon: mdiMessageQuestionOutline,
            label: `ユーザーマニュアル
よくある質問`,
        },
        {
            icon: mdiForumOutline,
            label: "お問い合わせ",
        },
        {
            externalLink:
                "https://spo-plus.com/shot/?utm_source=spo%2Btraining&utm_medium=referral&utm_campaign=member-page&utm_content=menu",
            img: shotSidebarBanner,
        },
    ],
];
